import React, { useState } from 'react'
import NavBar from '../components/nav-bar/Nav'
import SideBar from '../components/Sidebar'
import PageHeader from '../components/layout/PageHeader'
import EmailGrab from '../components/Hero/EmailGrab'
import FounderSpotlight from '../components/Builders/FounderSpotlight'
import FoundersGrid from '../components/Builders/FoundersGrid'
import { Band, BandInner, BandEyebrow, BandHeading, BandHeader } from '../components/Hero/HeroElements'
import { Helmet } from 'react-helmet-async'
import { HeroSpotlight, founders } from '../data/HeroSpotlight'

export default function BuildersPage() {
  const [isOpen, setIsOpen] = useState(false)
  const toggle = () => setIsOpen(!isOpen)

  return (
    <>
      <Helmet>
        <title>Founders | Vitalforce</title>
      </Helmet>

      <SideBar $isopen={isOpen} toggle={toggle} />
      <NavBar toggle={toggle} />

      <PageHeader
        eyebrow="Founders"
        title="The people behind the brands."
        lede="In their own words — why they started, and what they refused to compromise on."
      />

      <Band>
        <BandInner>
          <FounderSpotlight entries={HeroSpotlight} />
        </BandInner>
      </Band>

      <Band $tone="deep">
        <BandInner>
          <BandHeader>
            <div>
              <BandEyebrow>Everyone</BandEyebrow>
              <BandHeading>Founders we back.</BandHeading>
            </div>
          </BandHeader>
          <FoundersGrid founders={founders} />
        </BandInner>
      </Band>

      <EmailGrab />
    </>
  )
}
